import TourExclusion from '@/components/TourExclusion'


export default function TourExclusionPage() {
  return (
    <div>
     <TourExclusion/>
    </div>
  )
}
